import PropTypes from 'prop-types';
import React, { Component } from "react";
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { toSlug } from 'utils';

import {localTimeShort} from 'utils/LocalDateTimeHelper';
import { metaDescription } from 'utils/seoUtils';
import { HORSE_RACE_COMPLETE_STATUSES } from 'modules/Common/consts';
import Tabs from 'modules/Common/components/Tabs';
import RaceJSONLD from 'modules/Common/components/RaceJSONLD';

import HorseRacingRacecardSummary from "./HorseRacingRacecardSummary";
import HorseRacingRacecardPreRace from "./HorseRacingRacecardPreRace";
import HorseRacingRacecardPostRace from "./HorseRacingRacecardPostRace";

function racecardUrl(dateLong, meetingCourseName, raceId, raceName) {
  return `/racing/racecards/${dateLong}/${toSlug(meetingCourseName)}/racecard/${raceId}/${toSlug(raceName)}`;
}

function resultUrl(dateLong, meetingCourseName, raceId, raceName) {
  return `/racing/results/${dateLong}/${toSlug(meetingCourseName)}/${raceId}/${toSlug(raceName)}`;
}

export default class HorseRacingRacecardPage extends Component {
  static propTypes = {
    route: PropTypes.object,
    params: PropTypes.object,
    race: PropTypes.object,
    meeting: PropTypes.object,
    helmetRaceLabel: PropTypes.string,
    tipsArticle: PropTypes.object,
    raceId: PropTypes.object
  };

  constructor(...args) {
    super(...args);

    this.state = {
      haveCurrentOdds: this.ridesHaveCurrentOdds(this.props),
      sortOrder: "cloth"
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      haveCurrentOdds: this.ridesHaveCurrentOdds(nextProps)
    });
  }

  ridesHaveCurrentOdds({race: {rides}}) {
    const runners = rides.filter(ride => (ride.ride_status == "RUNNER"));
    const haveCurrentOdds = runners.map(runner => runner.betting.current_odds).some(r => r);

    return haveCurrentOdds;
  }

  setSortOrder(sortOrder) {
    this.setState({
      sortOrder
    });
  }

  render() {
    const {
      params, // to build urls
      route: {
        "result-racecard": showComponent
      },
      race, // for passing on
      tipsArticle,
      race: {
        race_summary: raceSummary, // for passing on
        race_summary : {
          date : dateLong,
          name: raceName,
          race_stage: raceStage,
          race_summary_reference: {
            id: singleRaceId
          } = {}
        },
        videos: raceVideos = [],
        prizes : {
          prize : prizes
        },
        stewards
      },
      helmetRaceLabel,
      meeting: {
        meeting: [singleMeeting],
        meeting: [
          {
            meeting_summary: {
              course: {
                name: meetingCourseName = 'unknown'
              }
            },
            races: meetingRaces = []
          } = {}
        ]
      } = {}
    } = this.props;

    let tabHref;
    let metaDesc;
    const isComplete = HORSE_RACE_COMPLETE_STATUSES.includes(raceStage);
    const pageTitle = [helmetRaceLabel];

    const cardProps = {race, isComplete, params};
    const summaryProps = {raceSummary, prizes, isComplete, params, stewards};
    const cardType = (showComponent == "result")?'result':'racecard';
    const provider = this.props.meeting.meeting.length > 0 ?
        this.props.meeting.meeting[0].meeting_summary.course.feed_source :
        'unknown';

    if (showComponent == "result") {
      tabHref = resultUrl;
      pageTitle.push("Result");
      if(raceVideos.length === 0){
        metaDesc = `Full result from the ${raceName} at ${meetingCourseName}`;
      }
      else {
        metaDesc = `Full result with video replay from the ${raceName} at ${meetingCourseName}`;
      }
    }
    else {
      tabHref = racecardUrl;
      pageTitle.push("Racecard");
      metaDesc = `${raceName} racecard with form, betting forecast and the Sporting Life verdict`;

      const {
        haveCurrentOdds,
        sortOrder
      } = this.state;

      summaryProps.sortOptions = [
        {text: "Cloth number", value: "cloth"},
        {text: "Horse A-Z",    value: "horse"}
      ];

      if (haveCurrentOdds) {
        summaryProps.sortOptions.splice(1, 0, {text: "Odds", value: "odds"});
      }

      summaryProps.setSortOrder = value => this.setSortOrder(value);
      summaryProps.sortOrder = cardProps.sortOrder = sortOrder;
    }

    const tabs = meetingRaces.map(({
      race_summary_reference: {
        id: raceId
      },
      name: raceName = 'unknown',
      date: raceDate,
      time: raceTime
    }) => ({
      href: tabHref(dateLong, meetingCourseName, raceId, raceName),
      text: localTimeShort(`${raceDate}T${raceTime}Z`)
    }));

    return <div>
      <RaceJSONLD meeting={singleMeeting} sport='racing' type={cardType} raceId={singleRaceId}/>
      <MetaDataWrapper title={pageTitle.join(" - ")} helmetProps={{...metaDescription(metaDesc)}}/>
      <section className="hr-racing-racecard-section">
        <Tabs {...{tabs}}/>

        <HorseRacingRacecardSummary {...summaryProps}/>
      </section>

      { (showComponent == "result") ?
        <HorseRacingRacecardPostRace {...cardProps} provider={provider}/>
      :
        <HorseRacingRacecardPreRace {...cardProps} {...{tipsArticle}}/>
      }
    </div>;
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacecardPage.js